div<template>
  <div class="bloco-divisao">
    <div class="modal-produto-item">
      <h3>EAN/GTIN</h3>
      <CenarioInput
        maxlength="14"
        tipo="texto"
        placeholder="Insira o EAN/GTIN"
        nome="ean"
        :validaCampos="validaCampos"
        :exibeValidacao="exibeValidacao"
        :model="ean"
        @update:model="update => calculaProdutosForm(update, 'ean')"
      />
    </div>
    <div class="modal-produto-item">
      <h3>DESTINAÇÃO <span>*</span></h3>
      <CenarioInput
        alignLeft
        placeholder="Escolha a Destinação"
        nome="destinacao"
        :validaCampos="validaCampos"
        :exibeValidacao="exibeValidacao"
        :model="destinacao"
        :options="destinacaoOptions.map(p => p.label)"
        @update:model="update => (destinacao = update)"
        @selected="
          update =>
            calculaProdutosForm(
              destinacaoOptions.find(f => f.label == update)
                ? destinacaoOptions.find(f => f.label == update).value
                : '',
              'id_destinacao'
            )
        "
      />
    </div>
  </div>
</template>

<script>
import CenarioInput from "../CenarioInput/CenarioInput.vue";

export default {
  name: "ModalProdutoDescricao",
  components: { CenarioInput },
  inject: ["calculaProdutosForm"],
  props: {
    exibeValidacao: Boolean,
    validaCampos: Object,
    produtosForm: Object
  },
  data() {
    return {
      ean: "",
      destinacao: "",
      destinacaoOptions: [
        {
          value: "1",
          label: "00 - Mercadoria para Revenda"
        },
        {
          value: "2",
          label: "01 - Matéria-Prima"
        },
        {
          value: "3",
          label: "02 - Embalagem"
        },
        {
          value: "4",
          label: "03 - Produto em Processo"
        },
        {
          value: "5",
          label: "04 - Produto Acabado"
        },
        {
          value: "6",
          label: "05 - Subproduto"
        },
        {
          value: "7",
          label: "06 - Produto Intermediário"
        },
        {
          value: "8",
          label: "07 - Material de Uso e Consumo"
        },
        {
          value: "9",
          label: "08 - Ativo Imobilizado"
        },
        {
          value: "10",
          label: "09 - Serviços"
        },
        {
          value: "11",
          label: "10 - Outros insumos"
        },
        {
          value: "12",
          label: "99 - Outras"
        }
      ]
    };
  },
  created() {
    this.$nextTick(() => {
      this.updateDados();
    });
  },
  watch: {
    produtosForm: {
      deep: true,
      handler() {
        this.updateDados();
      }
    }
  },
  methods: {
    updateDados() {
      this.ean = this.produtosForm.ean;
      let destinacao = this.destinacaoOptions.find(f => f.value == this.produtosForm.id_destinacao);
      this.destinacao = destinacao ? destinacao.label : "";
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  font-family: "Open Sans";
  font-weight: bold;
  font-size: 11px;
  text-transform: uppercase;
  color: #9ea2a7;
  span {
    color: red;
  }
}
.bloco-divisao {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 10px 10px;
}
.bloco-divisao-grupo {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  gap: 10px 10px;
}
.modal-produto-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>
